import {
  useMutation,
  ApolloClient,
  NormalizedCacheObject,
} from '@apollo/client'
import { captureWarning } from 'lib/monitoring'
import { SendWalletCardVariables, SendWalletCardResponse } from './types'
import { CREATE_WALLET_INVITATION_MUTATION } from 'lib/apollo/schema'

/**
 * Hook for sending wallet cards to patients
 * Uses the createWalletInvitation GraphQL mutation from the iservices API
 */
export const useSendWalletCardMutation = (
  client?: ApolloClient<NormalizedCacheObject>
) => {
  const [mutate, { loading, error }] = useMutation<
    SendWalletCardResponse,
    { createWalletInvitationInput: SendWalletCardVariables }
  >(CREATE_WALLET_INVITATION_MUTATION, {
    ...(client ? { client } : {}),
  })

  const sendWalletCard = async (variables: SendWalletCardVariables) => {
    try {
      const response = await mutate({
        variables: {
          createWalletInvitationInput: variables,
        },
      })

      return response
    } catch (error: any) {
      captureWarning(error)
      throw error
    }
  }

  return {
    sendWalletCard,
    loading,
    error,
  }
}
